import { createAsyncAction } from "typesafe-actions";
import overviewConstants from "store/features/templates/overivew/overview.constants";
import { Template, UserGroup } from "api";

const {
    FETCH_TEMPLATES_REQUEST,
    FETCH_TEMPLATES_SUCCESS,
    FETCH_TEMPLATES_FAILED,
    DELETE_TEMPLATE_REQUEST,
    DELETE_TEMPLATE_SUCCESS,
    DELETE_TEMPLATE_FAILED,
} = overviewConstants;

export const fetchTemplates = createAsyncAction(
    FETCH_TEMPLATES_REQUEST,
    FETCH_TEMPLATES_SUCCESS,
    FETCH_TEMPLATES_FAILED
)<void, { templates: Template[]; userGroups: UserGroup[] }, ErrorHandler>();

export const deleteTemplate = createAsyncAction(
    DELETE_TEMPLATE_REQUEST,
    DELETE_TEMPLATE_SUCCESS,
    DELETE_TEMPLATE_FAILED
)<string, void, ErrorHandler>();
